export const GET_ALL_PAGES = 'GET_ALL_PAGES';


